import _ from 'lodash';

export const extractInsightsListFromSetting = insightsSetting => {
  const categories =
    _.mapValues(insightsSetting, (value, key) => ({
      name: key,
      ...value
    })) || [];

  const orderedCategories = _.orderBy(categories, 'order');

  const insights = orderedCategories.reduce((acc, category) => {
    const catInsights = _.map(category?.insights, (insight, insightKey) => ({
      ...insight,
      key: insightKey,
      category: category.name
    }));
    return [...acc, ...catInsights];
  }, []);

  return insights;
};

export const extractInsightsByKeysFromSetting = insightsSetting => {
  const insightsList = extractInsightsListFromSetting(insightsSetting);
  const insightsByKeys = _.keyBy(insightsList, 'key');
  return insightsByKeys;
};
